import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-registered-lots-chart',
  templateUrl: './registered-lots-chart.component.html',
  styleUrls: ['./registered-lots-chart.component.css']
})
export class RegisteredLotsChartComponent implements OnInit {

  public lineChartData:Array<any> = [
    {data: [65, 59, 80, 81, 56, 55, 40, 45, 58, 80, 62, 56], label: 'Number'},
    {data: [28, 48, 40, 19, 86, 27, 90, 24, 78, 81, 56, 43], label: 'Volume'}
  ];
  public lineChartLabels:Array<any> = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  public lineChartOptions:any = {
    responsive: true
  };
  public lineChartColors:Array<any> = [
    {
      backgroundColor: 'rgba(255, 91, 121, 0.6)',
      pointBackgroundColor: 'rgb(255, 91, 121)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,83,96,1)'
    },
    {
      backgroundColor: 'rgba(255, 239, 178, 0.6)',
      pointBackgroundColor: 'rgb(255, 239, 178)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];
  public lineChartLegend:boolean = false;
  public lineChartType:string = 'line';

  constructor() { }

  ngOnInit() {
  }

}
